import React from 'react';
import PropTypes from 'prop-types';
import './Section.scss';

const Section = ({
  id,
  title,
  subtitle,
  children,
  variant = 'default',
  className = '',
  backgroundImage,
}) => {
  const sectionStyle = backgroundImage
    ? {
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }
    : {};

  return (
    <section
      id={id}
      className={`section section--${variant} ${className}`}
      style={sectionStyle}
    >
      {backgroundImage && <div className="section__overlay" />}
      <div className="container">
        {(title || subtitle) && (
          <div className="section__header">
            {title && (
              <h2 className="section__title" data-aos="fade-down" data-aos-delay="100">
                {title}
              </h2>
            )}
            {subtitle && (
              <p className="section__subtitle" data-aos="fade-up" data-aos-delay="200">
                {subtitle}
              </p>
            )}
          </div>
        )}
        <div className="section__content">{children}</div>
      </div>
    </section>
  );
};

Section.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['default', 'dark', 'primary', 'gradient']),
  className: PropTypes.string,
  backgroundImage: PropTypes.string,
};

export default Section;
